import { withSuspense } from '@/ui/utils/withSuspense'

import { PointsSkeleton } from './components/skeleton/PointsSkeleton'
import { GuestView } from '@/ui/organisms/guest-view/GuestView'
import { PointsView } from './views/PointsView'
import { useAccount } from '@/domain/hooks/useAccount'
import { usePrivy } from '@privy-io/react-auth'

function PointsContainer() {
  const account = useAccount()
  const { connectWallet } = usePrivy()

  if (!account) {
    return <GuestView openConnectModal={connectWallet} />
  }

  return <PointsView />
}

const PointsContainerWithSuspense = withSuspense(PointsContainer, PointsSkeleton)
export { PointsContainerWithSuspense as PointsContainer }
